import { HomeIcon, ToolsIcon, CoursesIcon, BookIcon, FolderIcon, CareerIcon, SelfIcon } from '@chegg-ui/theme';
export var HomeItem = {
  icon: HomeIcon,
  text: 'Home',
  href: ''
};
export var StudyToolsItem = {
  icon: ToolsIcon,
  text: 'Study tools',
  menuItems: [{
    text: 'Post a question',
    href: 'study/qa/post'
  }, {
    text: 'Take a practice test',
    href: 'tools/practice'
  }, {
    text: 'Find flashcards',
    href: 'tools/flashcards'
  }, {
    text: 'Solve math problems',
    href: 'math-solver'
  }, {
    text: 'Create citations',
    href: 'writing/citations/dashboard'
  }, {
    text: 'Check my writing',
    href: 'writing/dashboard'
  }, {
    text: 'Get expert proofreading',
    href: 'writing/features/proofreading'
  }]
};
/* There will be some dynamic fetched my-courses links as well, they will be pushed in the component asynchronously so that 
we don't block the rendering for rest of the nav-items */

export var MyCoursesItem = {
  icon: CoursesIcon,
  text: 'My courses',
  menuItems: [{
    text: '+ Add a course',
    href: '?bigegg=true#addCourse'
  }]
};
export var MyBooksItem = {
  icon: BookIcon,
  text: 'My books',
  href: 'books'
}; // My-Folders is not part of LWC August launch

export var MyFolderItem = {
  icon: FolderIcon,
  text: 'My folder',
  href: '/'
};
export var CareerItem = {
  icon: CareerIcon,
  text: 'Career',
  href: 'career'
};
export var SelfItem = {
  icon: SelfIcon,
  text: 'Life',
  href: 'introducing-chegg-life'
};
export var CreateDeckItem = {
  text: 'Create deck',
  href: 'flashcards/create-flashcards'
};
export var ExpertFlashcardsItem = {
  text: 'Expert flashcards',
  href: 'flashcards/expert-content'
};
export var MyFlashcardsItem = {
  text: 'My flashcards',
  href: 'flashcards/my-flashcards'
};